import { HTMLAttributes } from 'react';
import xss, { type IFilterXSSOptions } from 'xss';

type StringToHtmlProps = HTMLAttributes<HTMLElement> & {
  input: string;
  tag?: keyof HTMLElementTagNameMap;
  xssOptions?: IFilterXSSOptions;
};

export function StringToHtml({
  input,
  tag = 'div',
  xssOptions,
  ...props
}: StringToHtmlProps) {
  const Tag = tag as keyof JSX.IntrinsicElements;
  const customXss = {
    whiteList: {
      a: ['href', 'class', 'target', 'rel'],
      b: [],
      i: [],
      u: [],
    },
    stripIgnoreTag: true,
    ...xssOptions,
  };
  return (
    <Tag
      {...(props as any)}
      dangerouslySetInnerHTML={{ __html: xss(input, customXss) }}
    />
  );
}
